// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { atom } from "jotai";
var archivedElectionEventSelection = atom(false);
export default archivedElectionEventSelection;
